const railsHostName = process.env.REACT_APP_RAILS_APP_HOSTNAME || "";
const logout = `${railsHostName}/logout`;
const login = `${railsHostName}/login`;
const authenticateDevice = `${railsHostName}/companies/two_factor_authentications/send_email_login_link`;
const termsOfUse = "https://www.dailypay.com/legal/#terms-of-use";
const cycleProduct = "https://www.dailypay.com/cycle/";

const ExternalRoutes = {
  railsHostName,
  logout,
  login,
  authenticateDevice,
  termsOfUse,
  cycleProduct,
};

export default ExternalRoutes;
